var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.thisCellUrl ? 'clickable' : '',on:{"click":_vm.navigateToLink}},[_vm._v(_vm._s(_vm.params.valueFormatted))])])
}
var staticRenderFns = []

export { render, staticRenderFns }